import TeacherShell from '../../../components/layout/TeacherShell';
import SentenceStudio from '../../../components/sentence_studio/SentenceStudio';

// Original prototype, preserved verbatim while we decide which of its features
// and design choices to fold into the new vertical-nav Sentence Studio.
// Reachable at /teacher/sentence_studio_legacy.
export default function Legacy() {
  return (
    <TeacherShell maxWidth="full" className="!p-0" scrollTitle="Sentence Studio (legacy)">
      <SentenceStudio />
    </TeacherShell>
  );
}
